import angular from "angular";
import { timelineDirectiveDefinition, vsDirectiveName } from "./directive";

export const vsModuleName = "vis-timeline-directive-module";

angular
  .module(vsModuleName, [])
  .directive(vsDirectiveName, timelineDirectiveDefinition);
